import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage, injectIntl} from 'react-intl';
import {Field, reduxForm} from 'redux-form';
import Button from '../button/Button';
import FieldText from '../fields/fieldText/FieldText';

@injectIntl
@reduxForm({
  form: 'signIn'
})
export default class SignInForm extends React.PureComponent {
  render() {
    const {intl, handleSubmit, submitting, error} = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        {error && <span className="form__error">{error}</span>}

        <Field
          name="login"
          type="text"
          placeholder={intl.formatMessage({id: 'section.generic.email'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Field
          name="password"
          type="password"
          placeholder={intl.formatMessage({id: 'section.auth.password.title'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Button full filled loading={submitting} disabled={submitting}>
          <FormattedMessage id="section.auth.sign-in.action"/>
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/auth/SignInForm.js